// extracted by mini-css-extract-plugin
export default {"button":"FavoriteStar_button__21ze4","active":"FavoriteStar_active__65p2K"};